import { Checkbox, Chip, ListItemText, MenuItem, TextField } from "@mui/material";

export const MultipleSelectChip = ({ value, setValue, options, icon, ...props }) => {
	const handleChange = (opt) => {
		const newValue = value.some((o) => o?.id === opt.id) ? value.filter((o) => o.id !== opt.id) : [...value, opt];
		setValue(newValue);
	};

	return (
		<TextField
			select
			fullWidth
			size="small"
			value={value}
			SelectProps={{
				multiple: true,
				IconComponent: icon,
				renderValue: (selected) => (
					<>
						{selected.filter(Boolean).map(({ id, name }) => (
							<Chip key={id} label={name} />
						))}
					</>
				),
			}}
			sx={{
				"& .MuiSelect-select": {
					paddingLeft: 0,
					paddingTop: 0,
					paddingBottom: 0,
				},
				"& .MuiSvgIcon-root": {
					fontSize: "18px",
				},
				"& .MuiChip-label": {
					color: "#6c6c6c",
					fontSize: "10px",
					paddingLeft: "6px",
					paddingRight: "6px",
				},
				"& .MuiChip-root": {
					position: "relative",
					bottom: "2px",
					marginRight: "4px",
				},
				"& legend": {
					fontSize: "9px",
				},
			}}
			{...props}
		>
			{options.map((opt) => (
				<MenuItem key={opt.id} title={opt.name} selected={value.some((o) => o?.id === opt.id)} onClick={() => handleChange(opt)}>
					<Checkbox checked={value.some((o) => o?.id === opt.id)} />
					<ListItemText primary={opt.name} />
				</MenuItem>
			))}
		</TextField>
	);
};
